import * as THREE from 'three';
import Slice from './Slice';
import Segment from './Segment';

class Sculpture extends THREE.Mesh {
	constructor(spline) {
		super(
			new THREE.Geometry(),

			new THREE.MeshPhongMaterial({
				color: 0xdddddd,
				emissive: 0x000000,
				shininess: 50,
				wireframe: false,
				//				shading: THREE.SmoothShading,
				side: THREE.BackSide,
			})
		);

		this.angle = 0.2;
		this.rotationCount = 0.39;
		this.width = 0.45;
		this.widthOsculation = 0.125;
		this.speed = 0.1;

		this.t = 0;
		this.a = 0;

		this.spline = spline;
		this.create();
	}

	create() {
		this.slices = [];
		let i;
		for (i = 0; i < 150; i++) {
			const slice = new Slice(i, this.spline.curve, this.geometry);
			this.add(slice.mesh);
			this.slices.push(slice);
			slice.calculate();

			// copy default slice vertices
			this.geometry.vertices.push(...slice.vertices.map(v => new THREE.Vector3(v.x, v.y, v.z)));
		}

		const lastSliceIndex = this.slices.length - 1;

		for (i = 0; i < 150; i++) {
			const indexVerticesA = i === 0 ? lastSliceIndex : i - 1;
			const indexVerticesB = i;
			const sliceA = this.slices[indexVerticesA];
			const sliceB = this.slices[indexVerticesB];
			new Segment(sliceA, sliceB, indexVerticesA, indexVerticesB, this.geometry);
		}

		this.geometry.computeBoundingSphere();
		this.geometry.computeFaceNormals();
		this.geometry.computeVertexNormals(80);

		this.m = Math.PI / 150;
	}

	update = () => {
		const { vertices } = this.geometry;
		this.t++;

		this.rotation.y += 0.01;

		const { angle, rotationCount, width, widthOsculation, speed } = this;
		this.a += speed;

		this.slices.forEach((slice, sliceIndex) => {
			const multi = (1 - Math.cos((sliceIndex + this.a) * widthOsculation)) * 0.5;
			const multiRotation = (1 - Math.cos((sliceIndex + this.a) * 0.125)) * rotationCount;

			const axisVector = slice.mesh.position.clone().normalize();

			slice.vertices.forEach((v, vectorIndex) => {
				const i = sliceIndex * 6 + vectorIndex;
				const difference = slice.cacheDifference[vectorIndex];

				vertices[i].x = v.x - difference.x * width * multi;
				vertices[i].y = v.y - difference.y * width * multi;
				vertices[i].z = v.z - difference.z * width * multi;

				vertices[i].applyAxisAngle(axisVector, angle * multi * multiRotation);
			});
		});

		this.geometry.computeFaceNormals();
		this.geometry.computeVertexNormals(80);

		this.geometry.verticesNeedUpdate = true;
		this.geometry.elementsNeedUpdate = true;
		this.geometry.morphTargetsNeedUpdate = true;
		this.geometry.uvsNeedUpdate = true;
		this.geometry.normalsNeedUpdate = true;
		this.geometry.colorsNeedUpdate = true;
		this.geometry.tangentsNeedUpdate = true;
	};
}

export default Sculpture;



// WEBPACK FOOTER //
// ./src/threejs/sculpture/Sculpture.js